<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row class="h-full" :gutter="20">
      <el-col :span="6" class="h-full border-r-1">
        <div><span class="border-l-3 border-color-primary pl-10px text-18px">基本信息</span></div>
        <div class="mt-10px text-16px pl-10px">
          <div class="truncate mb-10px">实体名称： {{ classForm.name }}</div>
          <div class="truncate mb-10px">实体表名称： {{ classForm.tableName }}</div>
          <div class="truncate mb-10px">上级类别： {{ classForm.parentName }}</div>
          <div class="truncate mb-10px">主数据： {{ classForm.dataMainTypeName }}</div>
          <div class="truncate mb-10px">标签： {{ classForm.labelName }}</div>
        </div>
        <div class="mt-20px">
          <span class="border-l-3 border-color-primary pl-10px text-18px">表字段详情</span>
        </div>
        <div class="mt-20px h-[calc(100%-256px)]">
          <el-table border :data="attributeData" :loading="attributeLoading" height="100%">
            <el-table-column type="isPrimary" width="120" label="">
              <template slot-scope="scope">
                <div>
                  <el-tag v-if="scope.row.isPrimary" type="warning" class="!mr-5px">主键</el-tag>
                  <el-tag v-if="scope.row.isNullable" type="danger">非空</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="属性名称"></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="valueTypeName"
              label="属性类型"
              width="100"
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="mt-20px float-right"
          background
          @current-change="attrCurrentChange"
          @size-change="attrSizeChange"
          :current-page.sync="attrPage.pageNo"
          :page-size.sync="attrPage.pageSize"
          :page-sizes="$pageSizeAll"
          layout="total, sizes, prev, pager, next, jumper"
          :total="attrPage.total"
        ></el-pagination>
      </el-col>
      <el-col :span="isShowFlow ? 12 : 18" class="h-full">
        <div class="flex justify-end">
          <el-button
            type="primary"
            :disabled="!$hasAccess('application')"
            @click="addAuthApply"
            v-if="approveStatusName === '申请失败' && !isaudit"
            >添加权限申请</el-button
          >
          <el-button type="primary" @click="toPermissionChangeRecords" v-if="!isaudit"
            >权限变更记录</el-button
          >
          <el-button @click="goBack">返回</el-button>
        </div>
        <el-table
          class="mt-20px"
          v-loading="tableLoading"
          border
          height="calc(100% - 106px)"
          :data="tableData"
          ref="multipleTable"
        >
          <el-table-column type="index" width="55" label="序号">
            <template slot-scope="scope">
              <div>
                {{ scope.$index + 1 + page.pageSize * (page.pageNo - 1) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="authorizationRange"
            label="授权范围"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="authorizationRule"
            label="授权规则"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="endTime"
            label="权限有效期至"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="authorizationTime"
            label="授权时间"
          ></el-table-column>

          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                :disabled="!$hasAccess('reclaim') || scope.row.isValid === 1"
                size="mini"
                @click="setValid(scope.row)"
                >权限回收</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt-20px float-right"
          background
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          :page-sizes="$pageSizeAll"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </el-col>
      <el-col :span="6" class="h-full" v-show="isShowFlow">
        <workflow ref="workflow" :processData="processData" @close="close" @showFlow="showFlow" />
      </el-col>
    </el-row>

    <!--添加权限申请 -->
    <el-dialog
      title="添加权限申请"
      :visible.sync="showAuthApply"
      :close-on-click-modal="false"
      v-dialogDrag
      width="90%"
      top="5vh"
    >
      <authConfig
        v-if="showAuthApply"
        type="repeatAdd"
        :classId="classId"
        @closeRepeatAdd="closeRepeatAdd"
      />
    </el-dialog>
  </el-card>
</template>

<script>
import stdClassListService from '@/services/stdClassListService'
import stdClassLabelService from '@/services/stdClassLabelService'
import DataPermissionsService from '@/services/DataPermissionsService'
import workflow from '../../../components/workflow'
import authConfig from './authConfig'

export default {
  name: 'dataPermissionsDetail',
  components: { authConfig, workflow },
  data() {
    return {
      attributeLoading: false,
      attributeData: [],
      attrPage: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      tableLoading: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      classForm: {},
      classLabelList: [],
      showAuthApply: false,
      processData: {
        authorizationClassId: '',
      },
      isaudit: false,
      isShowFlow: false,
    }
  },
  computed: {
    classId() {
      return this.$route.query.classId
    },
    approveStatusName() {
      return this.$route.query.approveStatusName
    },
  },
  async created() {
    this.isaudit = this.$route.query.isaudit
    this.processData.authorizationClassId = this.$route.query.authorizationClassId
    await this.getClassLabelList()
    this.getClassDetail()
    this.searchAttrData()
    this.searchTableData()
  },
  methods: {
    // 获取表字段详情
    async searchAttrData() {
      this.attributeLoading = true
      const parameter = {
        class_id: this.classId,
        pageno: this.attrPage.pageNo,
        pagesize: this.attrPage.pageSize,
        is_all: true,
      }
      this.attributeLoading = false
      const res = await stdClassListService.getAttrList(parameter)
      if (res && res.code === 0) {
        this.attributeData = res.data
        this.attrPage.total = res.page.recordCount
      }
    },
    attrCurrentChange(num) {
      this.attrPage.pageNo = num
      this.searchAttrData()
    },
    attrSizeChange(size) {
      this.attrPage.pageSize = size
      this.searchAttrData()
    },
    async searchTableData() {
      const res = await DataPermissionsService.getClassAttributeAtributerule({
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        authorizationClassId: this.$route.query.authorizationClassId,
        authorizationDimensionId: this.$route.query.authorizationDimensionId,
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    // 获取基本信息
    async getClassDetail() {
      const res = await stdClassListService.classDetail({ id: this.classId })
      if (res && res.code === 0 && res.data) {
        this.classForm = res.data
        if (this.classForm.classLabelIds.length) {
          const labelName = []
          _.map(this.getClassLabelList, (item) => {
            if (_.includes(this.classForm.classLabelIds, item.id)) {
              labelName.push(item.name)
            }
          })
          this.$set(this.classForm, 'labelName', labelName.join('/'))
        } else {
          this.$set(this.classForm, 'labelName', null)
        }
      }
    },
    // 获取实体标签列表
    async getClassLabelList() {
      const res = await stdClassLabelService.getClassLabelList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (res && res.code === 0) {
        this.classLabelList = res.data
      }
    },
    // 权限回收
    async setValid(row) {
      this.$confirm('确定要回收该权限吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await DataPermissionsService.setValid({
            authorizationClassId: row.authorizationClassId,
            authorizationClassAtributeRuleId: row.id,
          })
          if (!res.message) {
            this.$message.success('权限回收成功')
            this.searchTableData()
          }
        })
        .catch()
    },
    // 添加权限申请
    addAuthApply() {
      this.showAuthApply = true
    },
    closeRepeatAdd() {
      this.showAuthApply = false
    },
    // 跳转权限变更记录
    toPermissionChangeRecords() {
      this.$router.push({
        path: './permission-change-records',
        query: {
          classId: this.$route.query.classId,
          authorizationClassId: this.$route.query.authorizationClassId,
          authorizationDimensionId: this.$route.query.authorizationDimensionId,
        },
      })
    },
    // 审核完成, 返回列表页
    close(val) {
      if (val) this.goBack()
    },
    // 是否显示工作流
    showFlow(val) {
      if (!this.isaudit) {
        this.isShowFlow = false
      } else {
        this.isShowFlow = val
      }
    },
    // 返回
    goBack() {
      this.isaudit = false
      this.isShowFlow = false
      this.$router.go(-1)
    },
  },
}
</script>
